


import {SessionAttendeeVM} from './SessionAttendeeVM'; 
import {SessionDuration} from './SessionDuration'; 
import {SessionType} from './SessionType'; 
export class SessionInfoVM {
    
    id?: string;
    
    me?: SessionAttendeeVM;
    
    otherParty?: SessionAttendeeVM;
    
    date?: Date;
    
    duration?: SessionDuration;
    
    durationInMins?: number;
    
    sessionType?: SessionType;
    
    sessionId?: string;
    
    combinedStartDateTime?: Date;
    
    combinedEndDateTime?: Date;
    
    orgId?: string;
    
}
